<mat-chip-list>
    <ng-container *ngIf="barcodes; else elseBlock">
        <mat-chip class="MatChip--dark">{{barcodes}}</mat-chip>
    </ng-container>
    <ng-template #elseBlock>
        <mat-chip class="MatChip--dark">{{ "products.table.noBarcodes" | translate }}</mat-chip>
    </ng-template>
</mat-chip-list>